<template>
    <div class="setTableColumns">
        <el-button @click="showCol()" type="text" size="mini">设置展示列</el-button>
        <el-dialog v-dialogDrag class="setTableColumnsDialog" :title="'设置展示列'" :visible.sync="setColDialog" :close-on-click-modal="false" width="300px" center append-to-body	>
            <div style="height: 60vh;overflow: auto;">
                <el-row>
                    <el-col class="line" :span="16">&nbsp;全选</el-col>
                    <el-col class="line" :span="8" style="text-align: center;">
                        <el-switch @change="changeAllShow()" v-model="allShow" active-color="#13ce66" :active-value="true" :inactive-value="false"></el-switch>
                    </el-col>
                </el-row>
                <div style="margin: 10px 0;border-top: 1px solid #ccc;"></div>
                <draggable v-model="colList" :options="{animation:200}">
                    <div class="drag-item" v-for="(item,i) in colList" :key="i">
                        <el-row>
                            <el-col class="line" :span="16">&nbsp;{{item.name}}</el-col>
                            <el-col class="line" :span="8" style="text-align: center;">
                                <el-switch v-model="item.show" active-color="#13ce66" :active-value="true"
                                           :inactive-value="false"></el-switch>
                            </el-col>
                        </el-row>
                    </div>
                </draggable>
            </div>
            <span slot="footer" class="dialog-footer">
<!--                <el-button size="mini" @click="reset()">重 置</el-button>-->
                <el-button size="mini" @click="setColDialog = false">取 消</el-button>
                <el-button type="primary" size="mini" @click="saveCol()">保 存</el-button>
              </span>
        </el-dialog>
    </div>
</template>
<script>
    import draggable from 'vuedraggable'
    import {userApi} from "@/api/organization";

    export default {
        //type: instrument 器具  audit 备案申请  inspection 检定申请
        //default  直接使用设置的数据，不走接口获取
        props: ['type','default'],
        data() {
            return {
                setColDialog: false,
                allShow: true,
                colList: [],
                InstrumentV2: [
                    {name: "器具名称", show: true, prop: "name", width: 250},
                    {name: "检定状态", show: true, prop: "checkResult", width: 90},
                    {name: "备案状态", show: true, prop: "checkType", width: 90},
                    {name: "器具项别", show: true, prop: "categoryName", width: 130},//对象特征
                    {name: "器具种别", show: true, prop: "className", width: 130},//测量对象
                    {name: "专业类别", show: true, prop: "majorName", width: 130},//专业大类
                    {name: "强检一级目录", show: true, prop: "catalogueOneName", width: 130},//一级目录
                    {name: "强检二级目录", show: true, prop: "catalogueTwoName", width: 130},//二级目录
                    {name: "唯一标识", show: true, prop: "instrNo", width: 170},
                    {name: "器具类型", show: true, prop: "typeName", width: 110},
                    {name: "器具用途", show: true, prop: "purposeName",width: 110},
                    {name: "规格型号", show: true, prop: "modelSpecific", width: 130},
                    {name: "制造单位", show: true, prop: "manufactoryName", width: 230},
                    {name: "出厂编号", show: true, prop: "serialNumber", width: 150},
                    {name: "内部编号", show: true, prop: "internalNumber"}
                ],
                instrument: [
                    {name: "器具名称", show: true, prop: "name"},
                    {name: "备案状态", show: true, prop: "checkType"},
                    {name: "器具项别", show: true, prop: "categoryName"},//对象特征
                    {name: "器具种别", show: true, prop: "className"},//测量对象
                    {name: "专业类别", show: true, prop: "majorName"},//专业大类
                    {name: "强检一级目录", show: true, prop: "catalogueOneName", width: "130"},//一级目录
                    {name: "强检二级目录", show: true, prop: "catalogueTwoName", width: "130"},//二级目录
                    // {name: "器具类别", show: true, prop: "addrName"},
                    {name: "唯一标识", show: true, prop: "instrNo", width: "180"},
                    {name: "器具类型", show: true, prop: "typeName"},
                    // {name: "强检器具", show: true, prop: "strong"},
                    {name: "制造单位", show: true, prop: "manufactoryName"},
                    {name: "规格型号", show: true, prop: "modelSpecific"},
                    {name: "型批证号", show: true, prop: "licence"},
                    {name: "出厂编号", show: true, prop: "serialNumber", width: "130"},
                    {name: "生产日期", show: true, prop: "productionTime", align: "center"},
                    {name: "内部编号", show: true, prop: "internalNumber"},
                    {name: "使用单位", show: true, prop: "useUnit"},
                    {name: "单位区域", show: true, prop: "useAddrName", width: "180"},
                    {name: "使用区域", show: true, prop: "useOrgAddrCode"},
                    {name: "使用位置", show: true, prop: "setupPlace"},
                    {name: "器具用途", show: true, prop: "purposeName"},
                    {name: "购置日期", show: true, prop: "purchaseDate"},
                    {name: "器具状态", show: true, prop: "states"},
                    {name: "使用部门", show: true, prop: "useDeptName"},
                    {name: "责任人员", show: true, prop: "custodianName"},
                    // {name: "测量范围 | 准确度等级", show: true, prop: "measureRange"},
                    {name: "测量范围", show: true, prop: "measureRange"},
                    // {name: "测量范围", show: true, prop: "measuringRangeV2"},
                    {name: "允许误差", show: true, prop: "indicationError"},
                    {name: "准确度等级", show: true, prop: "accuracyLevel", width: '130'},
                    {name: "分度值", show: true, prop: "divisionValue"},

                    {name: "检定档案", show: true, prop: "examineNum"},
                    {name: "备案", show: true, prop: "recordNum"},
                ],
                audit: [
                    {name: "器具名称", show: true, prop: "instrumentNames"},
                    {name: "审核单位", show: true, prop: "departName"},
                    {name: "审核人", show: true, prop: "auditUserName"},
                    {name: "审核日期", show: true, prop: "auditTime"},
                    {name: "审核结果", show: true, prop: "status"},
                    {name: "备案表编号", show: true, prop: "filingNo", width: '170'},
                    {name: "发起人", show: true, prop: "userName"},
                    {name: "联系电话", show: true, prop: "userMobile"},
                ],
                inspection: [
                    {name: "检定申请编号", show: true, prop: "orderApplyNumber", width: "210"},
                    {name: "业务状态", show: true, prop: "status"},
                    {name: "待办单位", show: true, prop: "agentMechanismName"},
                    {name: "待办人", show: true, prop: "agentName"},
                    {name: "待办人电话", show: true, prop: "agentMobile", width: "160"},
                    {name: "发起单位", show: true, prop: "initiatorMechanismName"},
                    {name: "发起人", show: true, prop: "initiatorName"},
                    {name: "发起人联系电话", show: true, prop: "initiatorMobile", width: "160"},
                    {name: "器具数", show: true, prop: "instrumentCount"},
                ],
                adminOrgan: [
                    {name: "备案申请单位", show: true, prop: "ownerName"},
                    {name: "备案表编号", show: true, prop: "filingNo", width: '170'},
                    {name: "器具数量", show: true, prop: "count"},
                    {name: "发起人", show: true, prop: "userName"},
                    {name: "联系电话", show: true, prop: "userMobile"},
                ],
                technical: [
                    {name: "检定申请编号", show: true, prop: "orderApplyNumber", width: "210"},
                    {name: "业务状态", show: true, prop: "status"},
                    {name: "待办单位", show: true, prop: "agentMechanismName"},
                    {name: "待办人", show: true, prop: "agentName"},
                    {name: "待办人电话", show: true, prop: "agentMobile", width: "160"},
                    {name: "发起单位", show: true, prop: "initiatorMechanismName"},
                    {name: "发起人", show: true, prop: "initiatorName"},
                    {name: "发起人联系电话", show: true, prop: "initiatorMobile", width: "160"},
                    {name: "器具数", show: true, prop: "instrumentCount"},
                ],
                measuringDialog: [
                    {name: "审核状态", show: true, prop: "status", width: 120},
                    {name: "使用状态", show: true, prop: "useStatus", width: 120},
                    // {name: "时效状态", show: true, prop: "agingStatus", width: 120},
                    {name: "建标单位", show: true, prop: "companyName"},
                    // {name: "所在区域", show: true, prop: "organizationRegion"},
                    {name: "计量标准名称", show: true, prop: "name"},
                    {name: "计量标准考核证书号", show: true, prop: "certificateNo", width: 180},
                    {name: "发证日期", show: true, prop: "issuedDate", width: 130},
                    {name: "有效期至", show: true, prop: "termValidity", width: 130},
                    // {name: "证书影印件", show: true, prop: "enclosure"},
                ],
                companyList: [
                    {name: "单位名称", show: true, prop: "name"},
                    {name: "统一社会信用代码", show: true, prop: "orgCode"},
                    {name: "单位地址", show: true, prop: "orgAddress"},
                    {name: "所属行业", show: true, prop: "industry"},
                    {name: "所属区划", show: true, prop: "${val1}"},
                    {name: "联系人", show: true, prop: "contactMan"},
                    {name: "联系人电话", show: true, prop: "contactMobile"},
                    {name: "授权证书", show: true, prop: "certCount"},
                ],
                authorizeProject: [
                    {name: "项目名称", show: true, prop: "name"},
                    {name: "使用状态", show: true, prop: "useStatus", width: 120},
                    {name: "现行状态", show: true, prop: "agingStatus", width: 120},
                    {name: "单位名称", show: true, prop: "orgName"},
                    {name: "所在区域", show: true, prop: "region", width: 120},
                    {name: "项目类型", show: true, prop: "certType", width: 120},
                    {name: "测量范围", show: true, prop: "surveyRange"},
                    {name: "依据技术规范", show: true, prop: "rules", width: 120},
                ],
                person:[
                    {name: "姓名", show: true, prop: "name", width: '110'},
                    {name: "性别", show: true, prop: "gender", width: '110'},
                    {name: "出生日期", show: true, prop: "birthday", width: '110'},
                    {name: "部门", show: true, prop: "departmentName"},
                    {name: "单位角色", show: true, prop: "orgRoleNames"},
                    {name: "学历", show: true, prop: "education"},
                    {name: "学位", show: true, prop: "degree"},
                    {name: "政治面貌", show: true, prop: "politicalStatus"},
                    {name: "参加工作日期", show: true, prop: "workStartTime", width: '130'},
                    {name: "计量工作年限", show: true, prop: "engagedStartTime", width: '130'},
                    // {name: "手机号码", show: true, prop: "phone"},
                    {name: "所在单位", show: true, prop: "organizationName"},
                ],
                mechanismV1:[
                    {name: "状态", show: true, prop: 'activeStatus', width: "80"},
                    // {name: "预警状态", show: true, prop: 'warnStatus', width: "110"},
                    {name: "单位代码", show: true, prop: "code"},
                    {name: "单位名称", show: true, prop: "name", width: '300'},
                    {name: "曾用名/别名", show: true, prop: "splitNameCount"},
                    {name: "单位类型", show: true, prop: "type"},
                    {name: "单位住所", show: true, prop: "residence"},
                    {name: "所在区域", show: true, prop: "${val1}"},
                    // {name: "联系人", show: true, prop: "realName", width: '120'},
                    // {name: "联系人手机号", show: true, prop: "phone"},
                    {name: "单位联系电话", show: true, prop: "landline"},
                    {name: "单位邮箱", show: true, prop: "email"},
                ],
                auditMechanismChangeApply: [
                  {name: "单位代码", show: true, prop: "code"},
                  {name: "单位名称", show: true, prop: "name", width: '300'},
                  {name: "联系人", show: true, prop: "userName", width: '120'},
                  {name: "联系人手机号", show: true, prop: "userMobile"},
                  {name: "单位联系电话", show: true, prop: "landline"}
                ],
                manufactory:[  //制造单位
                    {name: "单位代码", show: true, prop: "unifiedCreditCode"},
                    {name: "单位名称", show: true, prop: "name"},
                    {name: "单位地址", show: true, prop: "registerAddress"},
                    // {name: "所在区域", show: true, prop: "${val1}", align: "center"},
                    {name: "联系人", show: true, prop: "userName"},
                    // {name: "手机号", show: true, prop: "mobile"},
                ],
                userManage:[
                    {name: "状态", show: true, prop: "activeStatus", width: '80'},
                    {name: "用户类型", show: true, prop: "type", align: "center", width: '101'},
                    {name: "真实姓名", show: true, prop: "name", align: "center", width: '120'},
                    // {name: "手机号码", show: true, prop: "phone", align: "center", width: '120'},
                    {name: "单位名称", show: true, prop: "organizationName", align: "center", minWidth: '250'},
                    {name: "单位类型", show: true, prop: "organizationType", align: "center", width: '140'},
                    {name: "所在区域", show: true, prop: "organizationRegion", align: "center"},
                ],
                instrumentDict:[
                    {name: "器具/装置名称", show: true, prop: "name", width: '220'},
                    {name: "器具/装置别名", show: true, prop: "nameCount", width: '90'},
                    // {name: "测量范围", show: true, prop: "ranges", width: '180'},
                    {name: "专业类别", show: true, prop: "name1", width: '120'},
                    {name: "器具种别", show: true, prop: "name2"},
                    {name: "器具项别", show: true, prop: "name3"},
                    {name: "规程规范编号/名称", show: true, prop: "rules", width: '220'},
                    {name: "是否强检", show: true, prop: "strong"},
                    {name: "强检一级目录", show: true, prop: "catalogueOneName", width: "130"},
                    {name: "强检二级目录", show: true, prop: "catalogueTwoName", width: "130"},
                ],
                noMatchList: [
                    {name: "检定申请编号", show: true, prop: "orderApplyNumber", width: 170},
                    {name: "业务状态", show: true, prop: "checkStatus", width: 100},
                    {name: "发起单位", show: true, prop: "initiatorMechanismName"},
                    {name: "发起人", show: true, prop: "initiatorName", width: 120},
                    {name: "发起人联系电话", show: true, prop: "initiatorMobile", width: 150},
                    {name: "器具数量", show: true, prop: "count", width: 110},
                ],
                inspectOrder: [
                    {name: "检定机构名称", show: true, prop: "agentMechanismName", width: 260},
                    {name: "检定机构所属区域", show: true, prop: "agentMechanismRegion", width:160},
                    {name: "机构级别", show: true, prop: "agentMechanismLevel", width:100},
                    {name: "检定申请单编号", show: true, prop: "orderApplyNumber", width: 200},
                    {name: "报检日期", show: true, prop: "submitDate", width: 100},
                    {name: "业务状态", show: true, prop: "checkStatus", width: 100},
                    {name: "使用单位", show: true, prop: "initiatorMechanismName", width: 180},
                    {name: "使用单位所属区域", show: true, prop: "initiatorMechanismRegion", width:160},
                    {name: "器具数量", show: true, prop: "instrumentCount",width: 100, align: 'right'},
                ],
                inspectInstr: [
                    {name: "检定机构名称", show: true, prop: "agentMechanismName", width: 260},
                    {name: "检定机构所属区域", show: true, prop: "agentMechanismRegion", width:160},
                    {name: "机构级别", show: true, prop: "agentMechanismLevel", width:100},
                    {name: "检定申请单编号", show: true, prop: "orderApplyNumber", width: 200},
                    {name: "报检日期", show: true, prop: "submitDate", width: 100},
                    {name: "检定状态", show: true, prop: "checkResult", width: 100},
                    {name: "使用单位", show: true, prop: "initiatorMechanismName", width: 180},
                    {name: "使用单位所属区域", show: true, prop: "initiatorMechanismRegion", width:160},
                    {name: "器具名称", show: true, prop: "instr.name", width: 160},
                    {name: "器具项别", show: true, prop: "instr.categoryName", width: 100},//对象特征
                    {name: "器具种别", show: true, prop: "instr.className", width: 100},//测量对象
                    {name: "专业类别", show: true, prop: "instr.majorName", width: 100},//专业大类
                    {name: "强检一级目录", show: true, prop: "instr.catalogueOneName", width: 130},//一级目录
                    {name: "强检二级目录", show: true, prop: "instr.catalogueTwoName", width: 150},//二级目录
                    {name: "唯一标识", show: true, prop: "instr.instrNo", width: 160},
                    {name: "器具类型", show: true, prop: "instr.typeName", width: 120},
                    {name: "制造单位", show: true, prop: "instr.manufactoryName", width: 250},
                    {name: "规格型号", show: true, prop: "instr.modelSpecific", width: 150},
                    {name: "型批证号", show: true, prop: "instr.licence", width: 150},
                    {name: "出厂编号", show: true, prop: "instr.serialNumber", width: 120},
                    {name: "生产日期", show: true, prop: "instr.productionTime", width: 100},
                    {name: "内部编号", show: true, prop: "instr.internalNumber", width: 100},
                    {name: "器具用途", show: true, prop: "instr.purposeName", width: 100},
                ],
                auditOrder: [
                    {name: "行政部门名称", show: true, prop: "mechanismName"},
                    {name: "行政部门所属区域", show: true, prop: "mechanismRegion", width:160},
                    {name: "部门级别", show: true, prop: "mechanismLevel", width:100},
                    {name: "备案申请编号", show: true, prop: "filingNo", width: 150},
                    {name: "申请日期", show: true, prop: "launchTime", width: 100},
                    {name: "办理日期", show: true, prop: "auditTime", width: 100},
                    {name: "使用单位", show: true, prop: "initiatorMechanismName"},
                    {name: "器具数量", show: true, prop: "instrumentCount", width: 100, align: 'right'},
                ],
                auditInstr: [
                    {name: "行政部门名称", show: true, prop: "mechanismName", width: 260},
                    {name: "行政部门所属区域", show: true, prop: "mechanismRegion", width:160},
                    {name: "部门级别", show: true, prop: "mechanismLevel", width:100},
                    {name: "备案申请编号", show: true, prop: "filingNo", width: 150},
                    {name: "申请日期", show: true, prop: "launchTime", width: 100},
                    {name: "办理日期", show: true, prop: "auditTime", width: 100},
                    {name: "业务状态", show: true, prop: "auditStatus", width: 100},
                    {name: "使用单位", show: true, prop: "initiatorMechanismName", width: 250},
                    {name: "使用单位所属区域", show: true, prop: "initiatorMechanismRegion", width:160},
                    {name: "器具名称", show: true, prop: "instr.name", width: 160},
                    {name: "器具项别", show: true, prop: "instr.categoryName", width: 100},//对象特征
                    {name: "器具种别", show: true, prop: "instr.className", width: 100},//测量对象
                    {name: "专业类别", show: true, prop: "instr.majorName", width: 100},//专业大类
                    {name: "强检一级目录", show: true, prop: "instr.catalogueOneName", width: 130},//一级目录
                    {name: "强检二级目录", show: true, prop: "instr.catalogueTwoName", width: 150},//二级目录
                    {name: "唯一标识", show: true, prop: "instr.instrNo", width: 160},
                    {name: "器具类型", show: true, prop: "instr.typeName", width: 120},
                    {name: "制造单位", show: true, prop: "instr.manufactoryName", width: 250},
                    {name: "规格型号", show: true, prop: "instr.modelSpecific", width: 150},
                    {name: "型批证号", show: true, prop: "instr.licence", width: 150},
                    {name: "出厂编号", show: true, prop: "instr.serialNumber", width: 120},
                    {name: "生产日期", show: true, prop: "instr.productionTime", width: 100},
                    {name: "内部编号", show: true, prop: "instr.internalNumber", width: 100},
                    {name: "器具用途", show: true, prop: "instr.purposeName", width: 100},
                ],
                Regulations: [
                    {name: "审核状态", show: true, prop: "status", width: 110},
                    {name: "共享状态", show: true, prop: "shareStatus", width: 110},
                    {name: "文件标题", show: true, prop: "title"},
                    {name: "行文机关", show: true, prop: "agencyName", width: 250},
                    {name: "行文日期", show: true, prop: "writingDate", width: 110},
                    {name: "上传时间", show: true, prop: "createTime", width: 110},
                    {name: "文号条件", show: true, prop: "conditions", width: 250},
                    {name: "附件", show: true, prop: "enclosure", width: 70},
                ],
                rules:[
                    {name: "名称", show: true, prop: "name", width: 260},
                    {name: "编号", show: true, prop: "number", width: 180},
                    {name: "审核状态", show: true, prop: "auditStatus", width: 110},
                    {name: "共享状态", show: true, prop: "status", width: 110},
                    {name: "发布机关", show: true, prop: "releaseOfficeName", width: 210},
                    {name: "发布日期", show: true, prop: "releaseTime", width: 110},
                    {name: "实施日期", show: true, prop: "implementTime", width: 110},
                    {name: "实施区域", show: true, prop: "implementRegion", width: 110},
                    {name: "现行状态", show: true, prop: "currentStatus", width: 110},
                    {name: "代替文件", show: true, prop: "replaceRules", width: 150},
                    {name: "被代替文件", show: true, prop: "beReplaceRules", width: 150},
                    {name: "起草单位", show: true, prop: "draftUnitNum", width: 110},
                    {name: "起草人员", show: true, prop: "drafterNum", width: 110},
                    {name: "文本影印件", show: true, prop: "enclosure", width: 80},
                ],
                AuthorizeCertItem: [
                    {name: "项目名称", show: true, prop: "itemName", width: 180},
                    {name: "项目类型", show: true, prop: "itemType", width: 120},
                    {name: "机构名称", show: true, prop: "organizationName", width: 230},
                    {name: "证书编号", show: true, prop: "certificateNo", width: 220},
                    {name: "技术参数", show: true, prop: "surveyRanges", width: 80},
                    {name: "添加方式", show: true, prop: "manageStatus", width: 110},
                    {name: "审核状态", show: true, prop: "status", width: 110},
                    {name: "共享状态", show: true, prop: "shareStatus", width: 110},
                    {name: "现行状态", show: true, prop: "agingStatus", width: 110},
                    {name: "所在区域", show: true, prop: "organizationRegion", width: 160},
                    {name: "机构类型", show: true, prop: "organizationType", width: 150},
                    {name: "发证机关", show: true, prop: "issuingAuthority", width: 180},
                    {name: "发证日期", show: true, prop: "issuedDate", width: 110},
                    {name: "有效期至", show: true, prop: "termValidity", width: 110},
                ],
                AuthorizeCert: [
                    {name: "证书编号", show: true, prop: "certificateNo", width: 220},
                    {name: "机构名称", show: true, prop: "name", width: 230},
                    {name: "添加方式", show: true, prop: "manageStatus", width: 110},
                    {name: "审核状态", show: true, prop: "status", width: 110},
                    {name: "共享状态", show: true, prop: "shareStatus", width: 110},
                    {name: "现行状态", show: true, prop: "agingStatus", width: 110},
                    {name: "所在区域", show: true, prop: "organizationRegion", width: 160},
                    {name: "机构类型", show: true, prop: "organizationType", width: 150},
                    {name: "发证机关", show: true, prop: "issuingAuthority", width: 180},
                    {name: "法人代表", show: true, prop: "legalPerson", width: 100},
                    {name: "主管部门", show: true, prop: "competentDepartName", width: 180},
                    {name: "批准人", show: true, prop: "approverName", width: 100},
                    {name: "授权区域", show: true, prop: "authorizedArea", width: 160},
                    {name: "发证日期", show: true, prop: "issuedDate", width: 110},
                    {name: "有效期至", show: true, prop: "termValidity", width: 110},
                    {name: "影印件", show: true, prop: "enclosure", width: 80},
                ],
                PublicStandard: [
                    {name: "社会公用计量标准名称", show: true, prop: "standardName", width: 180},
                    {name: "计量标准代码", show: true, prop: "standardCode", width: 180},
                    {name: "计量标准\n技术参数", show: true, prop: "surveyRanges", width: 80},
                    {name: "社会公用计量标准证书号", show: true, prop: "certificateNo", width: 200},
                    {name: "建标单位", show: true, prop: "companyName", width: 230},
                    {name: "首次建\n标年份", show: true, prop: 'firstCreatedYear', width: 80},
                    {name: "传递区域或范围", show: true, prop: "transmitAddress", width: 200},
                    {name: "添加方式", show: true, prop: "manageStatus", width: 110},
                    {name: "使用状态", show: true, prop: "useStatus", width: 110},
                    {name: "审核状态", show: true, prop: "status", width: 110},
                    {name: "共享状态", show: true, prop: "shareStatus", width: 110},
                    {name: "现行状态", show: true, prop: "agingStatus", width: 110},
                    {name: "建标单位所在区域", show: true, prop: "organizationRegion", width: 160},
                    {name: "单位类型", show: true, prop: "organizationType", width: 150},
                    {name: "发证机关", show: true, prop: "issuingAuthority", width: 180},
                    {name: "发证日期", show: true, prop: "issuedDate", width: 110},
                    {name: "有效期至", show: true, prop: "termValidity", width: 110},
                    {name: "社公标证书影印件", show: true, prop: "enclosure",width: 80},
                ],
                Material: [
                  {name: "标准物质证书编号", show: true, prop: "certNumber",width:240},
                  {name: "标准物质名称", show: true, prop: "name", width:240},
                  {name: "标准物质等级", show: true, prop: "level"},
                  {name: "定级数据表", show: true, prop: "count", width: 130},
                  {name: "标准物质类型", show: true, prop: "type", width: 130},
                  {name: "标准物质形态", show: true, prop: "form", width: 130},
                  {name: "研制单位", show: true, prop: "mainDevOrgName", width: 250},
                  {name: "使用状态", show: true, prop: "useStatus", width: 110},
                  {name: "审核状态", show: true, prop: "status", width: 110},
                  {name: "共享状态", show: true, prop: "shareStatus", width: 110},
                  {name: "发证机关", show: true, prop: "issuingAuthority", width: 250},
                  {name: "发证日期", show: true, prop: "issuedDate", width: 120},
                  {name: "定级证书", show: true, prop: "attachFile", width: 120},
                ],
                MaterialOrg: [
                  {name: "状态", show: true, prop: "activeStatus", width: 80},
                  {name: "单位代码", show: true, prop: "code", width: 200},
                  {name: "单位名称", show: true, prop: "name", width: 280},
                  {name: "曾用名/别名", show: true, prop: "splitNameCount", width: 120},
                  {name: "联系人", show: true, prop: "userName", width: 120},
                  // {name: "联系人手机号", show: true, prop: "userMobile", width: 130},
                  {name: "单位地址", show: true, prop: "residence"},
                  {name: "标准物质证书数量", show: true, prop: "materialCount", width: 150},
                ],
                Standard: [
                    {name: "计量标准名称", show: true, prop: "name", width: 180},
                    {name: "计量标准代码", show: true, prop: "code", width: 130},
                    {name: "计量标准\n技术参数", show: true, prop: "surveyRanges", width: 80},
                    {name: "建标单位", show: true, prop: "companyName", width: 230},
                    {name: "首次建\n标年份", show: true, prop: 'firstCreatedYear', width: 80},
                    {name: "添加方式", show: true, prop: 'manageStatus', width: 110},
                    {name: "使用状态", show: true, prop: "useStatus", width: 110},
                    {name: "审核状态", show: true, prop: "status", width: 110},
                    {name: "共享状态", show: true, prop: "shareStatus", width: 110},
                    {name: "现行状态", show: true, prop: "agingStatus", width: 110},
                    {name: "建标单位所在区域", show: true, prop: "organizationRegion", width: 160},
                    {name: "单位类型", show: true, prop: "organizationType", width: 150},
                    {name: "计量\n标准器", show: true, prop: "devicesNum", width: 80},
                    {name: "主要配\n套设备", show: true, prop: "equipmentNum", width: 80},
                    {name: "开展的检定\n/校准项目", show: true, prop: "itemNum", width: 100},
                    {name: "开展的检定项目\n是否含强检器具", show: true, prop: "strongInstrNum", width: 130},
                    {name: "计量标准考核证书号", show: true, prop: "certificateNo", width: 180},
                    {name: "发证机关", show: true, prop: "issuingAuthority", width: 180},
                    {name: "发证日期", show: true, prop: "issuedDate", width: 110},
                    {name: "有效期至", show: true, prop: "termValidity", width: 110},
                    {name: "证书影印件", show: true, prop: "enclosure",width: 80},
                ],
                Devices: [
                    {name: "标准器名称", show: true, prop: "instrName", width: 140},
                    {name: "唯一标识", show: true, prop: "instrNo", width: 140},
                    {name: "测量范围", show: true, prop: "surveyRanges", width: 110},
                    {name: "规格型号", show: true, prop: "modelSpecific", width: 120},
                    {name: "计量标准名称", show: true, prop: "standardName", width: 180},
                    {name: "计量标准代码", show: true, prop: "standardCode", width: 130},
                    {name: "计量标准考核证书编号", show: true, prop: "certificateNo", width: 190},
                    {name: "建标单位", show: true, prop: "organizationName", width: 230},
                    {name: "检定状态", show: true, prop: "checkResult", width: 110},
                    {name: "使用状态", show: true, prop: "useStatus", width: 110},
                    {name: "所属区划", show: true, prop: "organizationRegion", width: 160},
                    {name: "单位类型", show: true, prop: "organizationType", width: 150},
                    {name: "专业类别", show: true, prop: "majorName", width: 110},
                    {name: "器具种别", show: true, prop: "className", width: 110},
                    {name: "器具项别", show: true, prop: "categoryName", width: 110},
                    {name: "制造单位", show: true, prop: "manufactoryName", width: 230},
                    {name: "出厂编号", show: true, prop: "serialNumber", width: 120},
                    // {name: "检定档案", show: true, prop: "examineNum", width: 110},
                ],
                Item: [
                    {name: "检定/校准项目名称", show: true, prop: "itemName", width: 180},
                    {name: "测量范围", show: true, prop: "surveyRanges", width: 110},
                    {name: "依据的规程规范编号", show: true, prop: "ruleNumber", width: 180},
                    {name: "依据的规程规范名称", show: true, prop: "ruleName", width: 180},
                    {name: "建标单位", show: true, prop: "organizationName", width: 230},
                    {name: "计量标准考核证书编号", show: true, prop: "certificateNo", width: 190},
                    {name: "计量标准名称", show: true, prop: "standardName", width: 180},
                    {name: "计量标准代码", show: true, prop: "standardCode", width: 130},
                ],
                Inspect_App_Order: [
                    {name: "检定机构名称", show: true, prop: "mechanismName"},
                    {name: "检定机构所属区域", show: true, prop: "mechanismRegion", width:160},
                    {name: "机构级别", show: true, prop: "mechanismLevel", width:100},
                    {name: "全部\n申请单", show: true, prop: "allAppCount",width:70, align: 'right'},
                    {name: "自动报检\n申请单", show: true, prop: "autoAssignAppCount",width:70, align: 'right'},
                    {name: "人工报检\n申请单", show: true, prop: "notAutoAssignAppCount",width:70, align: 'right'},
                    {name: "待分拣\n申请单", show: true, prop: "waitSortingAppCount",width:70, align: 'right'},
                    {name: "待办理\n申请单", show: true, prop: "waitAcceptedAppCount",width:70, align: 'right'},
                    {name: "自动分配\n器具数量", show: true, prop: "autoAssignInstrCount",width:90, align: 'right'},
                    {name: "无匹配\n申请单", show: true, prop: "noMatchAppCount",width:70, align: 'right'},
                    {name: "无匹配\n器具数量", show: true, prop: "noMatchInstrCount",width:90, align: 'right'},
                ],
                Inspect_Receive_Order: [
                    {name: "检定机构名称", show: true, prop: "mechanismName", width: 260},
                    {name: "检定机构所属区域", show: true, prop: "mechanismRegion", width:160},
                    {name: "机构级别", show: true, prop: "mechanismLevel", width:100},
                    {name: "接收报检\n器具数量", show: true, prop: "receiveInstrCount",width:70, align: 'right'},
                    {name: "自动报检\n器具数量", show: true, prop: "autoAssignInstrCount",width:70, align: 'right'},
                    {name: "人工报检\n器具数量", show: true, prop: "notAutoAssignInstrCount",width:70, align: 'right'},
                    {name: "未办理\n器具数量", show: true, prop: "notHandleInstrCount",width:70, align: 'right'},
                    {name: "待分拣\n器具数量", show: true, prop: "waitSortingInstrCount",width:70, align: 'right'},
                    {name: "待办理\n器具数量", show: true, prop: "waitHandleInstrCount",width:70, align: 'right'},
                    {name: "已办理\n器具数量", show: true, prop: "handleInstrCount",width:70, align: 'right'},
                    {name: "已受理\n器具数量", show: true, prop: "acceptedInstrCount",width:70, align: 'right'},
                    {name: "不受理\n器具数量", show: true, prop: "noAcceptedInstrCount",width:70, align: 'right'},
                    {name: "已检定\n器具数量", show: true, prop: "finishInstrCount",width:70, align: 'right'},
                    {name: "受理率（%）", show: true, prop: "acceptedRate",width:70, align: 'right'},
                    {name: "检定率（%）", show: true, prop: "finishRate",width:70, align: 'right'},
                    {name: "无匹配\n器具数量", show: true, prop: "noMatchInstrCount",width:70, align: 'right'},
                    {name: "待具证\n器具数量", show: true, prop: "waitProveInstrCount",width:70, align: 'right'},
                    {name: "已具证\n器具数量", show: true, prop: "proveInstrCount",width:70, align: 'right'},
                ],
                Inspect_Classify_Order: [
                    {name: "检定机构名称", show: true, prop: "mechanismName", width: 260},
                    {name: "检定机构所属区域", show: true, prop: "mechanismRegion", width:160},
                    {name: "机构级别", show: true, prop: "mechanismLevel", width:100},
                    {name: "合计", show: true, prop: "totalCount", width:70, align: 'right'},
                    {
                        "prop": "catalogueData.catalogue_1.catalogueCount",
                        "name": "验光仪器",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_139.catalogueCount",
                        "name": "热能表",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_8.catalogueCount",
                        "name": "加油机",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_10.catalogueCount",
                        "name": "加气机",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_14.catalogueCount",
                        "name": "透射式烟度计",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_16.catalogueCount",
                        "name": "乳汁计",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_18.catalogueCount",
                        "name": "电能表",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_26.catalogueCount",
                        "name": "医用活度计",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_28.catalogueCount",
                        "name": "呼出气体酒精含量检测仪",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_30.catalogueCount",
                        "name": "听力计",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_33.catalogueCount",
                        "name": "压力仪表",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_40.catalogueCount",
                        "name": "焦度计",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_42.catalogueCount",
                        "name": "出租汽车计价器",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_44.catalogueCount",
                        "name": "声级计",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_46.catalogueCount",
                        "name": "计量罐",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_50.catalogueCount",
                        "name": "非自动衡器",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_55.catalogueCount",
                        "name": "体温计",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_59.catalogueCount",
                        "name": "心脑电测量仪器",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_63.catalogueCount",
                        "name": "血压计（表）",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_66.catalogueCount",
                        "name": "流量计（口径范围DN300及以下）",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_77.catalogueCount",
                        "name": "放射治疗用电离室剂量计",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_79.catalogueCount",
                        "name": "糖量计",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_81.catalogueCount",
                        "name": "谷物容重器",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_83.catalogueCount",
                        "name": "燃气表",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_85.catalogueCount",
                        "name": "自动衡器",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_87.catalogueCount",
                        "name": "电动汽车充电桩",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_90.catalogueCount",
                        "name": "电力测量用互感器（500kV及以下）",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_95.catalogueCount",
                        "name": "眼压计",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_99.catalogueCount",
                        "name": "水表",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_102.catalogueCount",
                        "name": "轨道衡",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_105.catalogueCount",
                        "name": "医用诊断X射线设备",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_112.catalogueCount",
                        "name": "机动车测速仪",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    },
                    {
                        "prop": "catalogueData.catalogue_117.catalogueCount",
                        "name": "水分测定仪",
                        "show": true,
                        "width": 80,
                        "align": "right"
                    }                ]
            }
        },
        components: {draggable},
        created() {
            if(this.default){
                this.colList = this[this.type];
                this.$emit('changeTabCol', JSON.parse(JSON.stringify(this.colList)));
            }else{
                this.getData();
            }
        },
        methods: {
            getData(){
                userApi.getUserConfig({name: this.type}).then(r => {
                    if(r.data.result == 0){
                        const storage = r.data.data;
                        this.colList = storage?JSON.parse(storage.config):this[this.type];
                        if(this.colList.length !== this[this.type].length){
                            console.log("检测到长度不一致，自动重置");
                            this.reset();
                            this.saveCol();
                        }else{
                            for(const c in this.colList){
                                const index = this[this.type].findIndex(e => e.prop == this.colList[c].prop);
                                if(index == -1){
                                    console.log("检测到长度不一致，自动重置2");
                                    this.reset();
                                    this.saveCol();
                                    return;
                                }
                            }
                            this.$emit('changeTabCol', JSON.parse(JSON.stringify(this.colList)));
                        }
                    }
                })
            },
            showCol() {
                this.setColDialog = true;
            },
            reset() {
                this.colList = JSON.parse(JSON.stringify(this[this.type]));
                this.allShow = true;
            },
            saveCol() {
                userApi.updateUserConfig({name: this.type,config: JSON.stringify(this.colList)}).then(r => {
                    if(r.data.result == 0){
                        this.setColDialog = false;
                        this.$emit('changeTabCol', JSON.parse(JSON.stringify(this.colList)));
                    }
                })
            },
            changeAllShow(){
                this.colList.map(e=>e.show = this.allShow);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .setTableColumns {
        display: inline-block;
        margin-left: 8px;
    }
    .setTableColumnsDialog{
        .drag-item{
            border-bottom: 1px solid #ccc;
            cursor: s-resize;
            padding: 4px 0;
            &:last-child {
                border-bottom: none;
            }
        }
        .el-dialog__body{
            border: 1px solid red;
            overflow: auto;
            height: 60vh;
        }
    }
</style>
